var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.loggedIn && _vm.user)?_c('div',[_c('div',[_c('app-bars',{attrs:{"user":_vm.user,"slackMap":_vm.slackMap}}),_c('v-main',[_c('v-container',{staticClass:"py-8 px-6"},[_c('router-view')],1)],1)],1)]):_c('loginView',{on:{"auth":function($event){return _vm.login()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }